import React from 'react';
import IPlainCounter from './IPlainCounter';
import CountdownBase, { TReactCountdownNowCounter } from 'react-countdown-now';
import { classNames } from '@features/utils/reactFunctions';

import * as style from './PlainCounterStyle.module.scss'

const PlainCounter: React.FunctionComponent<IPlainCounter> = (props) => {
  const { timeLeft, onComplete, completedText } = props;

  const renderer = (counter: TReactCountdownNowCounter) => {
    const { days, hours, minutes, seconds, completed } = counter;

    if (completed) {
      onComplete();
      return <p>{completedText}</p>;
    }

    return (
      <div>
        {days > 0 && (
          <>
            <span>{days}</span>
            <span> days </span>
            :&nbsp;
          </>
        )}
        {(days > 0 || hours > 0) && (
          <>
            <span>{hours}</span>
            <span> hours </span>
            :&nbsp;
          </>
        )}
        {(days > 0 || hours > 0 || minutes > 0) && (
          <>
            <span>{minutes}</span>
            <span> {props.abbreviated ? 'mins' : 'minutes'} </span>
            :&nbsp;
          </>
        )}
        {(days > 0 || hours > 0 || minutes > 0 || seconds > 0) && (
          <>
            <span>{seconds}</span>
            <span> {props.abbreviated ? 'secs' : 'seconds'} </span>
          </>
        )}
      </div>
    );
  };

  return (
    <div className={classNames(style.plainCounter, props.addedClassName)}>
      {props.beforeText}
      <div className={style.base}>
        <CountdownBase now={props.now || undefined} date={timeLeft} renderer={renderer} />
      </div>
    </div>
  );
};

export default PlainCounter;
